<template>
  <div class="active-container">
    <div class="common-title">
      <span>活动</span>
    </div>
    <div class="item-container">
      <div
        @click="handle2active"
        class="item"
        v-for="(item, index) in activeList"
        :key="index"
        :style="{background: item.bg}"
      >
        <div :style="{color: item.color}">{{ item.value }}</div>
        <div :style="{color: item.color}">{{ item.label }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['activeList'],
  methods: {
    handle2active() {
      this.$router.push('/active')
    }
  }
}
</script>

<style scoped lang="scss">
.active-container {
  .item-container {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .item-container .item {
    width: 74px;
    height: 74px;
    border-radius: 12px;
    padding-top: 16px;
  }
  .item-container .item div {
    text-align: center;
    &:nth-child(1) {
      font-size: 20px;
    }
    &:nth-child(2) {
      padding-top: 3px;
      opacity: 0.64;
      font-size: 12px;
    }
  }
}
.common-title {
  padding: 16px 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  span {
    &:nth-child(1) {
      font-size: 16px;
      color: rgba(48, 49, 51, 1);
      font-weight: 700;
    }
    &:nth-child(2) {
      color: #909399;
      font-size: 13px;
    }
  }
}
</style>
